//@ts-nocheck
import { createContext } from 'react';
const NavigationContext = createContext({});
export default NavigationContext;